import { render, staticRenderFns } from "./SaleDocuments.vue?vue&type=template&id=37bbda87&scoped=true&"
import script from "./SaleDocuments.vue?vue&type=script&lang=ts&"
export * from "./SaleDocuments.vue?vue&type=script&lang=ts&"
import style0 from "./SaleDocuments.vue?vue&type=style&index=0&id=37bbda87&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37bbda87",
  null
  
)

export default component.exports